function l(...t){let e={};for(const n of t)n&&(e={...e,...n});return Object.keys(e).length?e:void 0}export{l as mergeStyles};
//# sourceMappingURL=merge-styles.js.map
